//分隔符separator斜杠
export const SEPARATOR_SLASH = "/";
/**
 * @file: 工具
 */
import moment from "moment";

/**
 * 去除空格
 *
 * @param {string} str 字符串
 * @return {Object} 字符串
 */
export function trim(str) {
  return (str + "").replace(/(^\s*)|(\s*$)/g, "");
}

/**
 * 获取当前时间阶段
 *
 * @param {datetime} dateTime 字符串
 * @return {string} 字符串
 */
export function getTimePeriod(dateTime) {
  let str = "";
  let dateTimeStr = moment(dateTime).format("YYYY-MM-DD HH:mm");
  let dayStr = moment(dateTime).format("YYYY-MM-DD") + " ";
  if (
    moment(dateTimeStr).isBefore(dayStr + "08:00") &&
    moment(dateTimeStr).isAfter(dayStr + "05:00")
  ) {
    str = "早晨";
  } else if (
    moment(dateTimeStr).isBefore(dayStr + "12:00") &&
    moment(dateTimeStr).isAfter(dayStr + "08:00")
  ) {
    str = "上午";
  } else if (
    moment(dateTimeStr).isBefore(dayStr + "14:00") &&
    moment(dateTimeStr).isAfter(dayStr + "12:00")
  ) {
    str = "中午";
  } else if (
    moment(dateTimeStr).isBefore(dayStr + "18:00") &&
    moment(dateTimeStr).isAfter(dayStr + "14:00")
  ) {
    str = "下午";
  } else if (
    moment(dateTimeStr).isBefore(dayStr + "19:00") &&
    moment(dateTimeStr).isAfter(dayStr + "18:00")
  ) {
    str = "傍晚";
  } else if (
    moment(dateTimeStr).isBefore(dayStr + "23:00") &&
    moment(dateTimeStr).isAfter(dayStr + "19:00")
  ) {
    str = "晚上";
  } else if (
    moment(dateTimeStr).isBefore(dayStr + "03:00") &&
    moment(dateTimeStr).isAfter(dayStr + "23:00")
  ) {
    str = "深夜";
  } else if (
    moment(dateTimeStr).isBefore("05:00") &&
    moment(dateTimeStr).isAfter("03:00")
  ) {
    str = "凌晨";
  }
  return str;
}

/**
 * 获取width、marginTop、paddingTop等
 *
 * @param {Object} obj 元素对象
 * @param {string} attr 字符串
 * @return {number} 字符串
 */
export function getStyle(obj, attr) {
  if (obj.currentStyle) {
    return +obj.currentStyle[attr].replace("px", "");
  } else {
    return +document.defaultView
      .getComputedStyle(obj, null)
      [attr].replace("px", "");
  }
}

export function inOf(arr, targetArr) {
  let res = true;
  arr.forEach((item) => {
    if (targetArr.indexOf(item) < 0) {
      res = false;
    }
  });
  return res;
}

export function oneOf(ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
}

export function setFormItemValue(targetArray, from) {
  for (let key in from) {
    for (let i = 0; i < targetArray.length; i++) {
      if (targetArray[i].props === key) {
        targetArray[i].value = from[key];
      }
    }
  }
}
export function findFormItemValue(formItems, prop) {
  for (let i = 0; i < formItems.length; i++) {
    if (formItems[i].props === prop) {
      return formItems[i].value;
    }
  }
  return null;
}

export function putObjToArray(obj, objArray) {
  let hasObj = false;
  for (let i = 0; i < objArray.length; i++) {
    if (objArray[i].value + "" === obj.value + "") {
      hasObj = true;
      return;
    }
  }
  objArray.push(obj);
  return objArray;
}
export function syncArray(sarr, darr) {
  for (let i = 0; i < sarr.length; i++) {
    let hasObj = false;
    for (let j = 0; j < darr.length; j++) {
      if (sarr[i].value + "" === darr[j].value + "") {
        hasObj = true;
      }
    }
    if (hasObj === false) {
      darr.push(sarr[i]);
    }
  }
  for (let i = 0; i < darr.length; i++) {
    let hasObj = false;
    for (let j = 0; j < sarr.length; j++) {
      if (sarr[j].value + "" === darr[i].value + "") {
        hasObj = true;
      }
    }
    if (hasObj === false) {
      darr.splice(i, 1);
      i--;
    }
  }
}

/**
 * 转换树形图数据
 *
 * param1：原始树形图数据
 * param2：显示的标题原始字段
 */
export function reformTree(tree, name = "orgName") {
  let cloneTree = JSON.parse(
    JSON.stringify(tree).replace(new RegExp(name, "g"), "title")
  );
  let data = cloneTree.filter((father) => {
    let branchArr = cloneTree.filter((child) => {
      return father.id == child.parentId;
    });
    if (branchArr.length > 0) {
      father.children = branchArr;
    }
    return father.parentId == -1;
  });
  return data;
}

export function getObjId(objList, field = "id") {
  let arr = [];
  objList.map((e) => {
    if (e.id || e.id == 0) {
      arr.push(e[field]);
    }
  });
  return arr;
}
// 验证是否是手机号码
export function isMobilePhone(str) {
  return /^1[0-9]{10}$/.test(str);
}

// 验证是否是座机号
export function isPhone(str) {
  return /^[0][1-9]{2,3}-[0-9]{5,10}$/.test(str);
}

// 验证是否是数字
export function isNumber(str) {
  return /^[0-9]*$/.test(str);
}
// 验证是否是数字
export function isEmail(str) {
  return /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(str);
}
// 验证是否是数字、浮点数
export function isFloat(str) {
  return /^[0-9]*[.]*[0-9]*$/.test(str);
}
/**
 * 格式化为JSON
 *
 * @param {string} str 字符串
 * @return {Object} 对象
 */
export function jsonParse(str) {
  if (!str) {
    return str;
  }
  return JSON.parse(str);
}

export function isObject(value) {
  const type = typeof value;
  return value != null && type === "object";
}

/**
 * 合并对象
 *
 * @param {Array} target 目标对象
 * @param {Object} src 来源对象
 * @param {Object} isCopyTargetKey 是否是拷贝target里的key
 * @return {Object} 结果
 */
export function merge(target, src, isCopyTargetKey) {
  const result = { ...target };
  if (!isCopyTargetKey) {
    Object.keys(src).forEach((key) => {
      if (src.hasOwnProperty(key)) {
        if (Array.isArray(src[key])) {
          result[key] = [].concat(src[key]);
        } else if (isObject(src[key])) {
          result[key] = merge({}, src[key]);
        } else {
          result[key] = src[key];
        }
      }
    });
  } else {
    Object.keys(target).forEach((key) => {
      if (target.hasOwnProperty(key)) {
        if (Array.isArray(src[key])) {
          result[key] = [].concat(src[key]);
        } else if (isObject(src[key])) {
          result[key] = merge({}, src[key]);
        } else {
          result[key] = src[key];
        }
      }
    });
  }
  return result;
}

/**
 * 列表转换为树
 *
 * @param {Array} data 数据源
 * @param {Object} options 选项参数
 * @return {Array} 树
 */
export function listToTree(data, options = {}) {
  let ID_KEY = options.idKey || "value";
  let PARENT_KEY = options.parentKey || "parentId";
  let CHILDREN_KEY = options.childrenKey || "children";
  // 单项数据内容
  let ITEM_OBJ = options.item || "";

  let tree = [];
  let childrenOf = {};
  let item;
  let id;
  let parentId;

  for (let i = 0, length = data.length; i < length; i++) {
    item = data[i];
    // 有item配置，重新更改item
    if (ITEM_OBJ) {
      for (let itemKey in ITEM_OBJ) {
        if (ITEM_OBJ.hasOwnProperty(itemKey)) {
          item[itemKey] = item[ITEM_OBJ[itemKey]];
        }
      }
    }
    id = item[ID_KEY];
    parentId = item[PARENT_KEY] || 0;
    // every item may have children
    childrenOf[id] = childrenOf[id] || [];
    // init its children
    item[CHILDREN_KEY] = childrenOf[id];

    if (parentId + "" !== "-1") {
      // init its parent's children object
      childrenOf[parentId] = childrenOf[parentId] || [];
      // push it into its parent's children object
      childrenOf[parentId].push(item);
    } else {
      tree.push(item);
    }
  }
  return tree;
}

// 转化为url&连接参数
export function convertToUrlParams(paramsMap, removeSpaceParam) {
  let str = "";
  for (let key of paramsMap) {
    if (paramsMap[key] || paramsMap[key] + "" === "0") {
      str += "&" + key + "=" + paramsMap[key];
    }
  }
  return str.substr(1);
}

// 计算字符串长度
export function getLength(str) {
  if (str == null) {
    return 0;
  }
  if (typeof str !== "string") {
    str += "";
  }
  return str.replace(/[^\x00-\xff]/g, "01").length;
}

export function formatDate(date, format) {
  if (!date) {
    return "";
  }
  return moment(date).format(format || "YYYY-MM-DD HH:mm:ss");
}

export function formatNum(num, isFixed) {
  if (!isNumber(num)) {
    return num;
  }
  if (isFixed) {
    return (num.toFixed(2) + "").replace(
      /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
      "$&,"
    );
  } else {
    return (num + "").replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
  }
}

// 验证密码 请输入6-30位字符，至少包含数字、大写字母、小写字母、特殊字符中的三种类型
export function checkPassword(str) {
  return /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{6,30}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{6,30}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{6,30}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{6,30}$))/.test(
    str
  );
}

// 剪切字符串
export function cutString(str, len) {
  if (!str) {
    return "";
  }
  let result = str.substring(0, len);
  if (str.length > len) {
    result += "...";
  }
  return result;
}

export function throttle(fn, delay, isDebounce) {
  let timer;
  let lastCall = 0;
  return function(...args) {
    if (isDebounce) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        fn(...args);
      }, delay);
    } else {
      const now = new Date().getTime();
      if (now - lastCall < delay) return;
      lastCall = now;
      fn(...args);
    }
  };
}

/**
 * 驼峰命名转换为_小写命名
 *
 * @param {name} name 字符串
 * @return {string} 字符串
 */
export function toLine(name) {
  return name.replace(/([A-Z])/g, "_$1").toLowerCase();
}

/**
 * 判断是否是手机设备
 *
 */
export function isMobileDevice() {
  if (/(iPhone|iPod|iOS|Android)/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

/**
 * 计算时间差并返回显示文本
 * @param {string} planFinishTime - 计划完成时间
 * @returns {string} 时间差文本
 */
export function getTimeDiffText(planFinishTime) {
  const now = moment();
  const finishTime = moment(planFinishTime);
  const diffMilliseconds = Math.abs(finishTime.diff(now));
  const duration = moment.duration(diffMilliseconds);

  // 获取天数、小时数、分钟数
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();

  if (finishTime.isBefore(now)) {
    // 已超期
    return `已超期${days}天${hours}小时${minutes}分`;
  } else {
    // 剩余时间
    return `剩余${days}天${hours}小时${minutes}分`;
  }
}
/**
 * 获取时间差文本的样式
 * @param {string} planFinishTime - 计划完成时间
 * @returns {object} 样式对象
 */
export function getTimeDiffStyle(planFinishTime) {
  const now = moment();
  const finishTime = moment(planFinishTime);

  if (finishTime.isBefore(now)) {
    // 已超期，红色显示
    return { color: "red", fontSize: "12px" };
  } else {
    // 剩余时间，黄色显示
    return { color: "#e6a23c", fontSize: "12px" };
  }
}

export const getDeadlineTime = (currentRowTime) => {
  if (!currentRowTime) return;

  const rowTime = new Date(currentRowTime);
  if (!rowTime instanceof Date) return;

  const nowTimestamp = new Date().getTime();
  const rowTimeTimestamp = rowTime.getTime();
  const diffMs = rowTimeTimestamp - nowTimestamp;

  const statusMap = { isOver: true, text: "已超期" };
  if (diffMs <= 0) {
    return statusMap;
  }

  statusMap.isOver = false;
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

  // 如果剩余时间超过24小时（即 days >= 1），显示天数
  if (days > 0) {
    statusMap.text = `剩余${days}天${hours}小时${minutes}分${seconds}秒`;
  } else {
    // 否则只显示小时、分钟、秒
    statusMap.text = `剩余${hours}小时${minutes}分${seconds}秒`;
  }
  console.log(statusMap, "statusMap");

  return statusMap;
};
